module.exports = __webpack_public_path__ + "static/media/logo_interattivo_new.ca73e457.svg";